import { UserCategory } from "../../types";

export const createAnalyticsContext = ({
    name,
    tableNo,
    tableId,
    pin,
    isUserHost,
    restaurantId,
}: {
    name: string;
    tableNo: string;
    tableId: string;
    pin: string;
    isUserHost: boolean;
    restaurantId: string;
}) => {
    return JSON.stringify({
        property_type: `Native_QR_Menu_StackedWidget-->${name}`,
        table_no: tableNo,
        table_id: tableId,
        pin: pin,
        "user-category": isUserHost ? UserCategory.PRIMARY : UserCategory.SECONDARY,
        restaurant_id: restaurantId,
    });
};
